import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffIcaosTab extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      staff_icaos: [],
      expiration: '',
      level: '',
      icaos: [
        {value: "NOT COMPLIANT", label: "NOT COMPLIANT"},
        {value: "1", label: "1"},
        {value: "2", label: "2"},
        {value: "3", label: "3"},
        {value: "4", label: "4"},
        {value: "5", label: "5"},
        {value: "6", label: "6"},
      ],
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    this.refreshData = this.refreshData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_icaos) && this.state.loaded === false) {
      this.setState({
        staff_icaos: newProps.staff_icaos,
        loaded: true
      });
    }
  }
  
  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     level: this.state.level,
  //     expiration: this.state.expiration,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api') + '/funcionario/icao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.refreshData();
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  // // Fetch ativando um item
  // activate(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse ICAO?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/icao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData();
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // delete(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse ICAO?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/icao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData();
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  // // Fetch deletando um item
  // archive(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse ICAO?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/icao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           self.refreshData();
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  refreshData () {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/icaos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_icaos: responseJson.data});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tituloICAOS}</h3>
  <hr/>
  {(this.state.staff_icaos === null || typeof this.state.staff_icaos === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.nenhumICAOCadastrado}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Level}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Vencimento}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.DataDeInsercao}</th>
          <th className="col-md-1 text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Status}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_icaos).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_icaos[k].level}</td>
              <td className="text-center">{self.state.staff_icaos[k].expiration_str}</td>
              <td className="text-center">{self.state.staff_icaos[k].date_str}</td>
              <td className="text-center">{(self.state.staff_icaos[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Arquivado}</span>}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Cadastrar ICAO</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Level:</label>
        <Select
          className="form-field-name"
          name="level"
          value={this.state.level}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'level')}
          options={this.state.icaos}
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Data de vencimento:</label>
        <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar ICAO</button>
  </form> */}
</div>
    );
  }
}

export default StaffIcaosTab;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/Elements/StaffIcaosTab.js